import { render } from "./SearchBox.vue?vue&type=template&id=479fdfc3&scoped=true"
import script from "./SearchBox.vue?vue&type=script&lang=ts"
export * from "./SearchBox.vue?vue&type=script&lang=ts"

import "./SearchBox.vue?vue&type=style&index=0&id=479fdfc3&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-479fdfc3"

export default script